import {
  FaTachometerAlt,
  FaUsers,
  FaCog,
  FaChartBar,
  FaExclamationTriangle,
  FaUserShield,
  FaChartPie,
} from "react-icons/fa";

/**
 * The single source for sidebar entries.
 *
 * adminMenu.jsx and userMenu.jsx were near-identical copies that had to be
 * edited in lockstep — and had already drifted: "Control Panel Users" existed
 * only in the admin copy, which is correct, but nothing made that intent
 * visible, so the next shared entry would likely have landed in one file only.
 * Both now compose from here, and the admin-only bit is explicit.
 *
 * Note there is deliberately NO entry for Schedules / Devices / Rooms: those
 * views are per-user and live as tabs under /admin/dash/users/:userId, reached
 * from the Subscriber list. A top-level entry would have nothing to render
 * until a user was chosen.
 */

export const INSIGHTS = {
  title: "Insights",
  path: "/admin/dash/insights",
  icon: <FaChartPie />,
};

export const BASE_MENU_HEAD = [
  INSIGHTS,
  {
    title: "Upcoming Schedules",
    path: "/admin/dash/dashboard",
    icon: <FaTachometerAlt />,
  },
  {
    title: "Global History Logs",
    path: "/admin/dash/logs-analytics",
    icon: <FaChartBar />,
  },
  {
    title: "API Usage Monitoring",
    path: "/admin/dash/usage-monitoring",
    icon: <FaExclamationTriangle />,
  },
  {
    title: "Trial Exploitation Monitoring",
    path: "/admin/dash/abuse-reports",
    icon: <FaUserShield />,
  },
  {
    title: "Subscriber",
    path: "/admin/dash/manage-users",
    icon: <FaUsers />,
  },
];

// Admin role only — managing who can reach the control panel.
export const ADMIN_ONLY = [
  {
    title: "Control Panel Users",
    path: "/admin/dash/manage-app-users",
    icon: <FaUsers />,
  },
];

export const BASE_MENU_TAIL = [
  {
    title: "Settings",
    path: "/admin/dash/settings",
    icon: <FaCog />,
  },
];
